var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:select-drag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 17H17V13H19V17H23V19H19V23H17V19H13V17ZM11 17V19H9V17H11ZM7 17V19H5V17H7ZM19 9V11H17V9H19ZM19 5V7H17V5H19ZM15 5V7H13V5H15ZM11 5V7H9V5H11ZM7 5V7H5V5H7ZM7 13V15H5V13H7ZM7 9V11H5V9H7Z",
    fill: "#242424"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.bdbb9ee3a456d24ec08f616dd351b1d9.svg";
export { ForwardRef as ReactComponent };